import ManageManufacturerTable from './ManageManufacturerTable'

const ManageManufacturer = {
  Table: ManageManufacturerTable,
}

export default ManageManufacturer
